<template>
  <div class="ele-wrap">
    <div class="content" style="
         {
          width: 100%;
        }
      ">
      <div class="search-box box">
        <time-search ref="timeSearch" :control="{ data: timeData }" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
          <div class="time-search-slot">
            <el-select style="width: 120px; margin-left: 10px" v-show="showSearchType" v-model="searchType">
              <el-option label="按小时间隔" value="hour"></el-option>
              <el-option label="按采集间隔" value="measuring"></el-option>
            </el-select>
          </div>
        </time-search>
      </div>
      <div class="grid-content item-box">
        <div class="details-content">
          <div class="byTitle" id="warpId" ref="datas">
            <el-tag style="margin-bottom: 7px" :title="item.name" v-for="(item, index) in dynamicTags" :key="index" closable :disable-transitions="false" @close="handleClose(index)">
              {{ item.omitName }}
            </el-tag>
            <el-button style="height: 30px; line-height: 0px; margin-left: 10px" type="primary" @click="addMeasure">添加计量点</el-button>
          </div>
          <div class="item-box chart-box box">
            <echart-line ref="analysisChart" :lineData="lineData" :searchType="searchType" :loading="loading"></echart-line>
          </div>
        </div>
      </div>
      <!-- 选择计量点开始 -->
      <el-dialog title="选择计量点" :visible.sync="showMeasure" width="700px" :close-on-click-modal="false">
        <div style="
            padding: 6px;
            background: #409eff;
            color: #fff;
            text-align: left;
          ">
          视图列表：
          <el-select style="width: 140px" size="mini" v-model="objId">
            <el-option v-for="(item, index) in viewData" :key="index" :value="item.id" :label="item.displayName"></el-option>
          </el-select>
          <!-- <el-checkbox style="margin-left:5px;padding:2px;background:#fff" v-model="checkStrictly">级联</el-checkbox> -->
        </div>
        <div class="tree-con">
          <!-- show-checkbox -->
          <!-- @node-click="leftTreeClick" -->
          <el-tree :data="treeData" node-key="id" ref="tree" show-checkbox @check-change="checkTree" default-expand-all :highlight-current="true" :expand-on-click-node="false" :check-strictly="checkStrictly" class="treeBox">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span class="node-label">{{ data.measureName }}</span>
            </span>
          </el-tree>
          <el-button style="height: 30px; line-height: 0px; margin-left: 20px" type="primary" @click="addView">添加</el-button>
        </div>
        <div class="topstyle" style="margin: 10px 7px">
          <label style="display: flex; align-items: center">数据项</label>
          <el-select style="width: 200px; margin-left: 10px" v-model="tabType" @change="changeTab($event)">
            <el-option v-for="(item, index) in tabData" :key="index" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </div>
        <div class="topstyle">计量点集合:</div>
        <div class="topstyle1">
          <el-tag style="margin-bottom: 7px" v-for="(item, index) in dynamicTagsNew" :key="index" closable :disable-transitions="false" @close="handleCloseNew(index)">
            {{ item.measureName }}
          </el-tag>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-right: 250px">
          <el-button @click="showMeasure = false">取 消</el-button>
          <el-button type="primary" @click="saveMeasure">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 选择计量点结束 -->
    </div>
  </div>
</template>
<script>
import tree from "@/utils/tree";
import * as fpg from "@/utils/fpg.js";
import echartLine from "./page/echartLine.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import dateTool from "@/utils/dateTool";
import elementResizeDetectorMaker from "element-resize-detector";
import uuidv1 from "uuid/v1";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "week",
    label: "周",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "timeInterval",
    label: "时段",
  },
];
let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  name: "ele",
  // 引用组件
  components: {
    echartLine,
    TimeSearch,
  },
  data () {
    return {
      timeData: allTimeData,
      warpId: uuidv1(),
      dateType: null,
      loading: false,
      tabData: [
        {
          label: "电压A相",
          value: "voltageA",
          type: "电压",
          code: "201",
          legend: "A相",
        },
        {
          label: "电压B相",
          value: "voltageB",
          type: "电压",
          code: "202",
          legend: "B相",
        },
        {
          label: "电压C相",
          value: "voltageC",
          type: "电压",
          code: "203",
          legend: "C相",
        },
        {
          label: "A相位角电压",
          value: "PHASE_ANGLE_VOLTAGE_A",
          type: "电压",
          code: "204",
          legend: "A相位角电压",
        },
        {
          label: "B相位角电压",
          value: "PHASE_ANGLE_VOLTAGE_B",
          type: "电压",
          code: "205",
          legend: "B相位角电压",
        },
        {
          label: "C相位角电压",
          value: "PHASE_ANGLE_VOLTAGE_C",
          type: "电压",
          code: "206",
          legend: "C相位角电压",
        },
        {
          label: "电流A相",
          value: "currentA",
          type: "电流",
          code: "207",
          legend: "A相",
        },
        {
          label: "电流B相",
          value: "currentB",
          type: "电流",
          code: "208",
          legend: "B相",
        },
        {
          label: "电流C相",
          value: "currentC",
          type: "电流",
          code: "209",
          legend: "C相",
        },
        {
          label: "零序电流",
          value: "CURRENT_ZERO",
          type: "电流",
          code: "210",
          legend: "零序电流",
        },
        {
          label: "总有功功率",
          value: "powerZy",
          type: "功率",
          code: "211",
          legend: "总有功功率(kW)",
        },
        {
          label: "A相有功功率",
          value: "ACTIVE_POWER_A",
          type: "功率",
          code: "212",
          legend: "A相有功功率",
        },
        {
          label: "B相有功功率",
          value: "ACTIVE_POWER_B",
          type: "功率",
          code: "213",
          legend: "B相有功功率",
        },
        {
          label: "C相有功功率",
          value: "ACTIVE_POWER_C",
          type: "功率",
          code: "214",
          legend: "C相有功功率",
        },
        {
          label: "总无功功率",
          value: "powerZw",
          type: "功率",
          code: "215",
          legend: "总无功功率(kVar)",
        },
        {
          label: "A相无功功率",
          value: "REACTIVE_POWER_A",
          type: "功率",
          code: "216",
          legend: "A相无功功率",
        },
        {
          label: "B相无功功率",
          value: "REACTIVE_POWER_B",
          type: "功率",
          code: "217",
          legend: "B相无功功率",
        },
        {
          label: "C相无功功率",
          value: "REACTIVE_POWER_C",
          type: "功率",
          code: "218",
          legend: "C相无功功率",
        },
        {
          label: "总功率因数",
          value: "TOTAL_POWER_FACTOR",
          type: "功率因数",
          code: "219",
          legend: "总功率因数",
        },
        {
          label: "A相功率因数",
          value: "factorA",
          type: "功率因数",
          code: "220",
          legend: "A相功率因数",
        },
        {
          label: "B相功率因数",
          value: "factorB",
          type: "功率因数",
          code: "221",
          legend: "B相功率因数",
        },
        {
          label: "C相功率因数",
          value: "factorC",
          type: "功率因数",
          code: "222",
          legend: "C相功率因数",
        },
        {
          label: "总视在功率",
          value: "powerZs",
          type: "功率",
          code: "223",
          legend: "总视在功率(kVA)",
        },
        {
          label: "A相视在功率",
          value: "APPARENT_POWER_A",
          type: "功率",
          code: "224",
          legend: "A相视在功率",
        },
        {
          label: "B相视在功率",
          value: "APPARENT_POWER_B",
          type: "功率",
          code: "225",
          legend: "B相视在功率",
        },
        {
          label: "C相视在功率",
          value: "APPARENT_POWER_C",
          type: "功率",
          code: "226",
          legend: "C相视在功率",
        },
        {
          label: "需量",
          value: "DEMAND",
          type: "频率",
          code: "228",
          legend: "需量",
        },
        {
          label: "正向有功总电能",
          value: "TOTAL_POSITIVE_ACTIVE_ENERGY",
          type: "频率",
          code: "229",
          legend: "正向有功总电能",
        },
        {
          label: "反向有功总电能",
          value: "TOTAL_POSITIVE_ACTIVE_ENERGY",
          type: "电能",
          code: "230",
          legend: "反向有功总电能",
        },
        {
          label: "正向五功总电能",
          value: "TOTAL_POSITIVE_REACTIVE_ENERGY",
          type: "电能",
          code: "231",
          legend: "正向无功总电能",
        },
        {
          label: "反向无功总电能",
          value: "TOTAL_REVERSE_REACTIVE_ENERGY",
          type: "电能",
          code: "232",
          legend: "反向无功总电能",
        },
        {
          label: "负荷率",
          value: "loadRate",
          type: "负荷率",
          code: "234",
          legend: "负荷率",
        },
        {
          label: "电压不平衡度",
          value: "imbalance",
          type: "不平衡度",
          code: "235",
          legend: "电压不平衡度",
        },
        {
          label: "电流不平衡度",
          value: "imbalance",
          type: "不平衡度",
          code: "242",
          legend: "电流不平衡度",
        },
        {
          label: "电压AB",
          value: "VOLTAGE_AB",
          type: "不平衡度",
          code: "249",
          legend: "电压AB",
        },
        {
          label: "电压BC",
          value: "VOLTAGE_BC",
          type: "不平衡度",
          code: "250",
          legend: "电压BC",
        },
        {
          label: "电压CA",
          value: "VOLTAGE_CA",
          type: "不平衡度",
          code: "251",
          legend: "电压CA",
        },
        {
          label: "电流AB",
          value: "CURRENT_AB",
          type: "不平衡度",
          code: "261",
          legend: "电流AB",
        },
        {
          label: "电流BC",
          value: "CURRENT_BC",
          type: "不平衡度",
          code: "262",
          legend: "电流BC",
        },
        {
          label: "电流CA",
          value: "CURRENT_CA",
          type: "不平衡度",
          code: "263",
          legend: "电流CA",
        },
        {
          label: "AB线有功功率",
          value: "ACTIVE_POWER_AB",
          type: "不平衡度",
          code: "264",
          legend: "AB线有功功率",
        },
        {
          label: "BC线有功功率",
          value: "ACTIVE_POWER_BC",
          type: "不平衡度",
          code: "265",
          legend: "BC线有功功率",
        },
        {
          label: "CA线有功功率",
          value: "ACTIVE_POWER_CA",
          type: "不平衡度",
          code: "266",
          legend: "CA线有功功率",
        },
        {
          label: "AB线无功功率",
          value: "REACTIVE_POWER_AB",
          type: "不平衡度",
          code: "267",
          legend: "AB线无功功率",
        },
        {
          label: "BC线无功功率",
          value: "REACTIVE_POWER_BC",
          type: "不平衡度",
          code: "268",
          legend: "BC线无功功率",
        },
        {
          label: "CA线无功功率",
          value: "REACTIVE_POWER_CA",
          type: "不平衡度",
          code: "268",
          legend: "CA线无功功率",
        },
        {
          label: "CA线无功功率",
          value: "REACTIVE_POWER_CA",
          type: "不平衡度",
          code: "269",
          legend: "CA线无功功率",
        },
        {
          label: "AB线视在功率",
          value: "APPARENT_POWER_AB",
          type: "不平衡度",
          code: "270",
          legend: "AB线视在功率",
        },
        {
          label: "BC线视在功率",
          value: "APPARENT_POWER_BC",
          type: "不平衡度",
          code: "271",
          legend: "BC线视在功率",
        },
        {
          label: "CA线视在功率",
          value: "APPARENT_POWER_CA",
          type: "不平衡度",
          code: "272",
          legend: "CA线视在功率",
        },
        {
          label: "AB线功率因数",
          value: "POWER_FACTOR_AB",
          type: "不平衡度",
          code: "273",
          legend: "AB线功率因数",
        },
        {
          label: "BC线功率因数",
          value: "POWER_FACTOR_BC",
          type: "不平衡度",
          code: "274",
          legend: "BC线功率因数",
        },
        {
          label: "CA线功率因数",
          value: "POWER_FACTOR_CA",
          type: "不平衡度",
          code: "275",
          legend: "CA线功率因数",
        },
        {
          label: "总正向流量",
          value: "TOTAL_POSITIVE_FLOW",
          type: "水量",
          code: "401",
          legend: "总用量",
        },
        {
          label: "总反向流量",
          value: "TOTAL_POSITIVE_FLOW_QUANTITY",
          type: "正向流量",
          code: "402",
          legend: "正向流量",
        },
        {
          label: "流速",
          value: "FLOW_RATE",
          type: "流速",
          code: "403",
          legend: "流速",
        },
        {
          label: "压力",
          value: "pressure",
          type: "压力",
          code: "404",
          legend: "压力",
        },
        {
          label: "密度",
          value: "density",
          type: "密度",
          code: "405",
          legend: "密度",
        },
        {
          label: "总热能",
          value: "TOTAL_FLOW_HEAT",
          type: "总热能",
          code: "406",
          legend: "总热能",
        },
        {
          label: "总冷能",
          value: "TOTAL_COOLING_HEAT",
          type: "总冷能",
          code: "407",
          legend: "总冷能",
        },
        {
          label: "热功率",
          value: "POWER_HEAT",
          type: "热功率",
          code: "408",
          legend: "热功率",
        },
        {
          label: "冷功率",
          value: "POWER_COOLING",
          type: "冷功率",
          code: "409",
          legend: "冷功率",
        },
        {
          label: "A相绕组温度",
          value: "temperatureA",
          type: "A相绕组温度",
          code: "501",
          legend: "A相绕组温度度",
          pointNumber: "0",
        },
        {
          label: "B相绕组温度",
          value: "temperatureB",
          type: "B相绕组温度",
          code: "502",
          legend: "B相绕组温度",
          pointNumber: "1",
        },
        {
          label: "C相绕组温度",
          value: "temperatureC",
          type: "C相绕组温度",
          code: "503",
          legend: "C相绕组温度",
          pointNumber: "2",
        },
        {
          label: "温度",
          value: "temperatureA",
          type: "温度",
          code: "501",
          legend: "温度",
          pointNumber: "0",
        },
        {
          label: "湿度",
          value: "temperatureA",
          type: "湿度",
          code: "502",
          legend: "湿度",
          pointNumber: "0",
        },
        {
          label: "状态",
          value: "STATE",
          type: "表码",
          code: "601",
          legend: "状态",
        },
        {
          label: "计数",
          value: "COUNT",
          type: "表码",
          code: "601",
          legend: "计数",
        },
      ],
      searchType: "hour",
      tabShow: true,
      selectedTab: "",
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      showSearchType: true,
      //运行状态
      tabType: "电压A相",
      tabSelect: {},
      dynamicTags: [],
      dynamicTagsNew: [],
      showMeasure: false,
      viewData: [],
      objId: null,
      treeData: [],
      lineData: {},
      treeSelect: {},
      itemCode: "201", //选中数据项的code
      measureName: "",
      treeDataNew: [],
      putTree: [],
      checkStrictly: true,
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    let vm = this;
    vm.tabSelect = vm.tabData[0];
    let time = new Date();
    let startTime = dateTool.format(time, "yyyy-MM-dd ") + "00:00:00";
    time.setDate(time.getDate() + 1);
    let endTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
    vm.selectedDate = {
      dataType: "1",
      dateType: "day",
      endTime: endTime,
      startTime: startTime,
    };
    vm.TimeControlClick(vm.selectedDate);
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.init();
    });
  },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {
    selectedTab (val, oldVal) {
      this.updateData(val, oldVal);
    },
    objId (val) {
      let vm = this;
      vm.getViewTreeNodes(val);
    },
    tabType (val) {
      let vm = this;
      vm.isShowSearchType();
    },
    searchType (val) { },
  },
  // 方法定义
  methods: {
    timeControlChange (e) {
      this.selectedDate = e;
      this.isShowSearchType();
    },
    //查询
    TimeControlClick (e) {
      let vm = this;
      this.selectedDate = e;
      vm.getData();
    },
    //切换数据项
    changeTab (row, code) {
      this.tabSelect = this.tabData.find((obj) => {
        return obj.label == row;
      });
      this.itemCode = this.tabSelect.code;
    },
    //获取数据
    getData () {
      let vm = this;
      vm.loading = true;
      vm.dateType = vm.selectedDate.dateType;
      let pointNumber = "0";
      let num = vm.tabSelect.pointNumber ? vm.tabSelect.pointNumber : "0";
      let startTime = vm.selectedDate.startTime;
      let endTime = vm.selectedDate.endTime;
      //生成measures
      let lineData = {
        xData: [],
        series: [],
        legend: [],
      };
      if (vm.dynamicTags.length == 0) {
        vm.loading = false;
        vm.lineData = {
          xData: [],
          series: [],
          legend: [],
        };
      }
      vm.dynamicTags.forEach((item, i) => {
        let measures = [];
        lineData.series[i] = {
          data: [],
          type: "line",
          name: item.omitName,
        };
        lineData.legend[i] = item.omitName;
        item.id.map((obj, i) => {
          measures.push({
            measureId: obj,
            pointNumber: num,
            pointCode: item.code[i],
          });
        });
        if (vm.searchType == "hour") {
          vm.$api.measuring
            .getMeasuringValueHour2(measures, startTime, endTime, 0)
            .then((resArr) => {
              if (!resArr.success) {
                vm.$message.error(resArr.msg);
                return;
              }
              let echartsData = vm.merge(resArr.data);
              lineData.xData = fpg.getXdata(
                vm.selectedDate.startTime,
                vm.selectedDate.endTime,
                vm.selectedDate.dateType
              ); //获取柱状图x轴
              let timeData = JSON.parse(
                JSON.stringify(
                  fpg.getMatchTimeData(
                    vm.selectedDate.startTime,
                    vm.selectedDate.endTime,
                    "0"
                  )
                )
              ); //匹配查询时间 [{00:}]
              lineData.series[i].data = [];
              timeData.forEach((item) => {
                echartsData.forEach((obj) => {
                  if (obj.time.substring(0, 13) == item.time.substring(0, 13)) {
                    item.value = obj.value === "" ? "-" : obj.value.toFixed(2);
                  }
                });
                lineData.series[i].data.push(item.value);
              });
              vm.lineData = JSON.parse(JSON.stringify(lineData));
              vm.loading = false;
            });
        } else {
          vm.$api.measuring
            .getMeasuringValueAll2(measures, startTime, endTime, 0)
            .then((resArr) => {
              if (!resArr.success) {
                vm.$message.error(resArr.msg);
                return;
              }
              lineData.xData = [];
              lineData.series[i].data = [];
              lineData.series[i].timeData = [];
              let echartsData = vm.merge(resArr.data, "cj");
              /* 将时间数据顺序 */
              echartsData.sort((a, b) => {
                return new Date(a.time).getTime() - new Date(b.time).getTime();
              });
              echartsData.forEach((item) => {
                // lineData.xData.push(item.time)
                lineData.series[i].timeData.push({
                  value: item.value,
                  time: item.time,
                });
              });
              let match = vm.getSe(lineData.series, lineData);
              console.log(match);
              vm.lineData = JSON.parse(JSON.stringify(match));
              vm.loading = false;
            });
        }
      });
    },
    /* 求出相同时间，并补空的值 */
    getSe (data, lineData) {
      let resData = [];
      data.map((item, i) => {
        resData.push({
          data: [],
          matchData: [],
        });
        if (item.timeData) {
          item.timeData.map((temp) => {
            resData[i].matchData.push(temp);
          });
        }
      });
      /* 获取长度最大的点做x轴 */
      let maxData = this.getMax(resData);
      lineData.xData = [];
      for (let i = 0; i < maxData.length; i++) {
        lineData.xData.push(maxData[i].time);
        for (let j = 0; j < resData.length; j++) {
          const maxIndex = resData[j].matchData.find(
            (c) => c.time == maxData[i].time
          );
          if (!maxIndex) {
            resData[j].data.push({ value: "", time: maxData[i].time });
          } else {
            resData[j].data.push({
              value: maxIndex.value,
              time: maxIndex.time,
            });
          }
        }
      }
      /* 将时间数据顺序 */
      //   lineData.xData=[]
      for (let i = 0; i < resData.length; i++) {
        resData[i].data.sort((a, b) => {
          return new Date(a.time).getTime() - new Date(b.time).getTime();
        });
      }
      /* 将value放进echarts里面 */
      resData.forEach((item, i) => {
        lineData.series[i].data = [];
        item.data.forEach((temp) => {
          // lineData.xData.push(temp.time)
          lineData.series[i].data.push(
            temp.value === ""
              ? (temp.value = "-")
              : Number(temp.value).toFixed(2)
          );
        });
      });
      return lineData;
    },
    /* 求二维数组长度最大的数组 */
    getMax (resData) {
      let leng = 0;
      let sArr = []; /* 得出最大长度 */
      let n = [];
      for (var i in resData) {
        if (resData[i].matchData.length > leng) {
          sArr = resData[i].matchData;
          leng = resData[i].matchData.length;
          n = [parseInt(i) + 1];
        } else {
          if (resData[i].matchData.length == leng) {
            sArr.push(resData[i].matchData);
            n.push(parseInt(i) + 1);
          }
        }
      }
      return sArr;
    },
    //将相同计量点数据合并
    merge (resArr, type) {
      let res = [];
      let newArr = [];
      //思路  先将所有的数组整合到一个新数组，然后把相同time的数据放进一个新数组，然后再把相同time的value相加并去重
      resArr.forEach((item, key) => {
        item.data.data.forEach((obj) => {
          newArr.push(obj);
        });
      });
      return this.deteleObject(newArr, type);
    },
    //将相同的time相加并去重
    deteleObject (res, type) {
      var newArr = [];
      res.forEach((item) => {
        var dataItem = item;
        if (newArr.length > 0) {
          /* 因为分秒可能不同，因此直接取到小时 */
          var filterValue = null;
          if (type == "cj") {
            filterValue = newArr.filter((v) => {
              /* 采集间隔 */
              return v.time == dataItem.time;
            });
          } else {
            filterValue = newArr.filter((v) => {
              /* 小时间隔 */
              return v.time.substring(0, 13) == dataItem.time.substring(0, 13);
            });
          }

          if (filterValue.length > 0) {
            newArr.forEach((n) => {
              if (type == "cj") {
                if (n.time == filterValue[0].time) {
                  n.value = filterValue[0].value + dataItem.value;
                }
              } else {
                if (
                  n.time.substring(0, 13) ==
                  filterValue[0].time.substring(0, 13)
                ) {
                  n.value = filterValue[0].value + dataItem.value;
                }
              }
            });
          } else {
            newArr.push(dataItem);
          }
        } else {
          newArr.push(dataItem);
        }
      });
      return newArr;
    },
    /**
     * 是否显示采集间隔下拉框
     */
    isShowSearchType () {
      let vm = this;
      let isShowSearchType = vm.tabSelect.label;
      if (
        isShowSearchType == "用电量" ||
        isShowSearchType == "负荷率" ||
        isShowSearchType == "正向流量" ||
        isShowSearchType == "反向流量"
      ) {
        vm.showSearchType = false;
      } else {
        if (vm.selectedDate.dateType == "day") {
          vm.showSearchType = true;
        } else {
          vm.showSearchType = false;
          vm.searchType = "hour";
        }
      }
    },
    //数据项集合关闭
    handleClose (index) {
      this.dynamicTags.splice(index, 1);
    },
    //数据项集合关闭
    handleCloseNew (index) {
      this.dynamicTagsNew.splice(index, 1);
      this.TimeControlClick(this.selectedDate);
    },
    //添加计量点
    addMeasure () {
      let vm = this;
      vm.showMeasure = true;
      (vm.tabType = "电压A相"), vm.getCompanyViewTreesInfo();
      vm.dynamicTagsNew = [];
      this.putTree = [];
      this.$refs.tree.setCheckedKeys([]);
      //   vm.treeSelect = {}
    },
    //加载视图列表数据
    getCompanyViewTreesInfo () {
      let vm = this;
      api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            vm.viewData = res.data;
            if (res.data.length > 0) {
              vm.objId = res.data[0].id;
            }
          }
        });
    },
    //视图树点击
    // leftTreeClick(data) {
    //   let vm = this
    //     vm.treeSelect =JSON.parse(JSON.stringify(data));
    //   this.measureName=data.measureName
    // },
    //视图树勾选事件
    checkTree (data, ifCheck, childCheck) {
      let vm = this;
      if (ifCheck) {
        vm.putTree.push(data);
      } else {
        let itemInedex = vm.putTree.findIndex((obj) => obj.id == data.id);
        if (itemInedex > -1) {
          vm.putTree.splice(itemInedex, 1);
        }
      }
    },
    //添加视图
    addView () {
      let vm = this;
      vm.dynamicTagsNew = [];
      vm.putTree.forEach((temp, i) => {
        let item = vm.dynamicTagsNew.find((obj) => {
          return obj.id == temp.id && obj.code == this.itemCode;
        });
        if (!item) {
          let temp1 = JSON.parse(JSON.stringify(temp));
          this.measureName = temp1.measureName;
          temp1.measureName = JSON.parse(
            JSON.stringify(this.measureName + "(" + vm.tabType + ")")
          );
          vm.dynamicTagsNew.push(Object.assign({ code: this.itemCode }, temp1));
        }
      });
    },
    //获取视图数据
    getViewTreeNodes (id) {
      api.view.getViewTreeNodes(id).then((res) => {
        let item = this.viewData.find((obj) => obj.id === id);
        let templates = [];
        api.measure.getMeasureTemplates().then((obj) => {
          templates = obj.data;
        });
        item.templates = templates;
        this.objItem = item;
        let data = tree.creatTreeJson(res.data, 0);
        this.treeDataNew = res.data;
        this.treeData = data;
        this.putTree = [];
      });
    },
    //选择计量点
    saveMeasure () {
      let vm = this;
      if (vm.dynamicTagsNew.length == 0) {
        vm.$message({
          type: "warning",
          message: "请先添加视图点",
        });
        return;
      } else {
        let obj = { name: "", id: [], code: [] };
        vm.dynamicTagsNew.map((item) => {
          obj.name += "+" + item.measureName;
          obj.id.push(item.measureId);
          obj.code.push(item.code);
        });
        obj.name = obj.name.substr(1);
        if (obj.name.length < 20) {
          obj.omitName = obj.name;
        } else {
          obj.omitName = obj.name.slice(0, 20) + "...";
        }
        vm.dynamicTags.push(obj);
      }
      vm.TimeControlClick(vm.selectedDate);
      vm.showMeasure = false;
    },
  },
};
</script>
<style scoped>
.treeBox >>> .el-tree-node {
  min-height: 26px;
}
</style>>
<style scoped>
.treeBox >>> .el-tree-node {
  min-height: 26px;
}
</style>
<style lang="scss">
.time-search-slot {
  .el-input__inner,
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
}
</style>
<style lang="scss" scoped>
.ele-wrap {
  height: 100%;
  padding: 14px;
  display: flex;
  box-sizing: border-box;
}
.content {
  width: 100%;
}
.grid-content {
  position: relative;
  height: calc(100% - 50px);
}
.details-content {
  width: 100%;
  height: 100%;
}
.table-content {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.table-layout {
  width: calc(100% + 20px);
  height: 340px;
  margin: -10px -10px -10px -10px;
}
.table-layout td {
  width: 25%;
}
.table-layout tr {
  height: 100%;
}
.item-box {
  width: 100%;
  text-align: left;
  margin-top: 14px;
}
.tab-box {
  height: 30px;
}
.chart-box {
  background: none;
  //   height: calc(100% - 64px);
  height: 93%;
  margin-bottom: 14px;
}
.search-box {
  height: 36px;
}
.table-box {
  // padding-bottom: 20px;
}
.homocycle-ratio-box {
  width: 100%;
  height: 120px;
  padding: 10px;
  box-sizing: border-box;
}
.byTitle {
  //   height: 50px;
  //   line-height: 50px;
  background: #fff;
  border-radius: 4px;
  color: #fff;
  padding: 7px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.custom-tree-node {
  width: 100%;
  padding-right: 20px;
  display: flex;
  align-items: center;
}
.custom-tree-node .node-label {
  flex: 1;
  text-align: left;
}
.custom-tree-node .node-btn {
  padding: 0px 6px;
}
.tree-con {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.treeBox {
  display: flex;
  flex-flow: column;
  flex: 3;
  height: 250px;
  overflow: auto;
}
.topstyle {
  text-align: left;
  margin: 7px;
  display: flex;
  flex-wrap: wrap;
}
.topstyle1 {
  text-align: left;
  margin: 7px;
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow: auto;
}
</style>